/*jshint esversion: 6 */
// import store from '@/store/index';
import UltraRoute from '@/router/components/UltraRoute.js';
import WaggonEditor from '@/router/modules/WaggonEditor.module.js';

function Template(payload) {
  let route = UltraRoute({
    name: `${payload.location}Waggons`, 
    path: 'workbench/:template_type/folder/:wagfolder/waggons', 
    folder: 'WorkBenchRework', 
    file: 'WorkBenchWaggons', 
    auth:true, 
    props: () => {
      return {
        location: payload.location
      };
    },
    children: [
      WaggonEditor({
        location: payload.location,
        nav_back: `${payload.location}Waggons`,
      })
  ]});
  return route;
}
export default Template;
